import { CANVAS_ARROW_COLOR } from "../styles/Canvas";
import { AbstractShape } from "../abstract/Shape";
import { ArrowStyle } from "../enums/ArrowType";
import { ConnectionRenderer } from "../abstract/ConnectionRenderer";

export class Connection extends ConnectionRenderer {
    constructor(
        id: string,
        from: string,
        to: string,
        x1: number,
        y1: number,
        x2: number,
        y2: number,
        iFrom: AbstractShape,
        iTo: AbstractShape,
        type: string,
        name: string,
        lineColor: string = CANVAS_ARROW_COLOR,
        arrowType?: ArrowStyle,
    ){
        super(
            id,
            from,
            to,
            x1,
            y1,
            x2,
            y2,
            iFrom,
            iTo,
            type,
            name,
            lineColor,
            arrowType,
        );
        this.id = id;
        this.from = from;
        this.to = to;
        this.x1 = x1;
        this.y1 = y1;
        this.x2 = x2;
        this.y2 = y2;
        this.lineColor = lineColor;
        this.iFrom = iFrom;
        this.iTo = iTo;
        this.type = type;
        this.name = name;
        this.currentLineColor = lineColor;
        this.arrowStyle = arrowType || ArrowStyle.SOLID;
    }
}